<template>
    <div class="container-fluid">

        <div class="container-white">
            <div class="row no-gutters">
                <div class="col-sm-3 col-xl-2">
                    <nav class="navbar navbar-light navbar-expand-sm navbar-app">

                        <a class="navbar-brand" :href="homeUrl">
                            <img :src="homeUrl + '/' + 'logo.png'" />
                        </a>


                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav-menu"
                                aria-controls="nav-menu" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="nav-menu collapse navbar-collapse" id="nav-menu">
                            <ul class="navbar-nav flex-column">
                                <router-link class="nav-item" to="/" exact active-class="active" tag="li">
                                    <a class="nav-link"><i class="fas fa-clock"></i> Tracker</a>
                                </router-link>

                                <router-link class="nav-item" to="/projects" active-class="active" tag="li">
                                    <a class="nav-link"><i class="fas fa-folder"></i> Projects</a>
                                </router-link>

                                <router-link class="nav-item" to="/clients" active-class="active" tag="li">
                                    <a class="nav-link"><i class="fas fa-user"></i> Clients</a>
                                </router-link>

                                <router-link class="nav-item" to="/reports" active-class="active" tag="li">
                                    <a class="nav-link"><i class="fas fa-chart-pie"></i> Reports</a>
                                </router-link>

                                <router-link class="nav-item" to="/settings" active-class="active" tag="li">
                                    <a class="nav-link"><i class="fas fa-cog"></i> Settings</a>
                                </router-link>


                                <li class="nav-item">
                                    <a class="nav-link" href="#"
                                       onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
                                        <i class="fas fa-sign-out-alt"></i> Log out
                                    </a>

                                    <form id="logout-form" :action="homeUrl + '/logout'" method="POST" style="display: none;">
                                        <input type="hidden" name="_token" :value="csrfToken" />
                                    </form>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>

                <div class="col-sm-9 col-xl-8">
                    <main style="" class="m-3">
                        <router-view :homeUrl="homeUrl"
                                     :timezones="timezonesParsed"
                                     :now="now"
                                     :today="today"
                                     :clients="clientsParsed"
                                     v-on:forgot-user="logout"
                                     v-on:preferences-changed="reactToUpdatedPreferences"
                        />
                    </main>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    const HEARTBEAT_TIMEOUT = 30000;

    export default {
        props: [
            "homeUrl",
            "timezones",
            "now",
            "today",
            "clients",
            "userPreferences"
        ],

        data() {
            return {
                localUserPreferences: this.userPreferences,
                pingTimeoutId: null,
            };
        },

        computed: {
            csrfToken() {
                return document.head.querySelector("[name=csrf-token]").content
            },
            timezonesParsed() {
                return JSON.parse(this.timezones);
            },
            clientsParsed() {
                return JSON.parse(this.clients);
            }
        },

        mounted() {
            window.axios.defaults.baseURL = this.homeUrl;

            const that = this;
            window.setTimeout(function() {

                // I just met you. And it's crazy. But here's my number...
                that.soPingMeMaybe();

            }, HEARTBEAT_TIMEOUT)
        },

        methods: {
            logout() {
                // If 401, bring auth
                window.location.href = this.homeUrl + "/login";
            },

            reactToUpdatedPreferences(data) {
                this.localUserPreferences = Object.assign({}, data);
                this.soPingMeMaybe();
            },

            // send pings home if needed
            async soPingMeMaybe() {
                // cancel any existing timeouts and return;
                if (this.pingTimeoutId) {
                    window.clearTimeout(this.pingTimeoutId);
                    this.pingTimeoutId = null;
                }

                if (!this.localUserPreferences.clockout_on_offline) {
                    return ;
                }

                try {
                    await window.axios.post("/api/ping");
                } catch (error) {

                };
                this.pingTimeoutId = window.setTimeout(this.soPingMeMaybe, HEARTBEAT_TIMEOUT);
            }
        }
    }
</script>
